import { render, staticRenderFns } from "./Productss.vue?vue&type=template&id=c95ffee0&"
import script from "./Productss.vue?vue&type=script&lang=js&"
export * from "./Productss.vue?vue&type=script&lang=js&"
import style0 from "./Productss.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports